var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 59,
    viewBox: "0 0 42 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8625 15.5889L5.08833 7.38711C10.6377 0.47804 19.6004 -1.36861 27.3045 0.948646L14.8625 15.5889Z",
    fill: "#4274EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9828 19.8077C42.6387 36.4449 24.3784 45.1154 22.951 57.7702C22.4752 59.4099 19.6205 59.4099 19.1363 57.7702C18.3294 52.8064 15.1728 48.2785 11.6492 43.7679L26.7219 26.1341L27.4785 25.2489L39.6956 10.9558C41.0274 13.5061 41.8511 16.4685 41.9828 19.8077Z",
    fill: "#60A850"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.104548 19.8077C-0.316467 23.5589 0.567473 27.0075 2.15539 30.2804L14.8625 15.5889L5.08833 7.38711C2.60129 10.4835 0.799838 14.5967 0.104548 19.8077Z",
    fill: "#DA2F2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15539 30.2804C4.45299 35.016 8.22445 39.3838 11.6492 43.7679L26.7219 26.1341C20.3342 32.4612 8.4393 24.4937 14.8625 15.5889L2.15539 30.2804Z",
    fill: "#ECB72B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6956 10.9558C37.0702 5.92847 32.4703 2.50246 27.3045 0.948646L14.8625 15.5889C22.4182 7.4697 33.2792 17.5836 27.4785 25.2489L39.6956 10.9558Z",
    fill: "#5085F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c02b90eb32fe85cbf9f7d161064526e4.svg";
export { ForwardRef as ReactComponent };